import { createContext } from "react";

const PageItemContext = createContext({});

export default PageItemContext;
